import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import countries from "../../../../../../assets/countries.json";
import { JsonPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-address-form",
    imports: [
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatSelectModule,
        JsonPipe,
        TranslateModule,
    ],
    templateUrl: "./address-form.component.html",
    styleUrl: "./address-form.component.scss"
})
export class AddressFormComponent implements OnInit {
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() initialValue: any;
  form: FormGroup;
  countryList = countries;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      COUNTRY: [""],
    });
  }

  ngOnInit() {
    this.form.setValue({
      COUNTRY: this.initialValue?.COUNTRY || "",
    });
    this.form.valueChanges.subscribe((value) => {
      this.onChange.emit(value);
    });
  }
}
